module.exports = __webpack_public_path__ + "img/down_text_top.16bdcdfc.png";